import { ButtonGroup, ToggleButton } from '@pocketlaw/tetris';
import { getViewLabel } from './utils';
import { usePlai, PlaiViewType } from '../PlaiProvider';
export function ViewSwitcher() {
    const { view, updateView } = usePlai();
    return (<ButtonGroup>
      {Object.values(PlaiViewType).map(value => (<ToggleButton key={value} $stretch $toggled={view === value} appearance="primary" onClick={() => {
                updateView(value);
            }}>
          {getViewLabel(value)}
        </ToggleButton>))}
    </ButtonGroup>);
}
